import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Partners from './pages/Partners';
import PartnerDetails from './pages/PartnerDetails';
import Advertisers from './pages/Advertisers';
import AdvertiserDetails from './pages/AdvertiserDetails';
import Campaigns from './pages/Campaigns';
import CampaignDetails from './pages/CampaignDetails';
import Conversions from './pages/Conversions';
import ConversionDetails from './pages/ConversionDetails';
import Analytics from './pages/Analytics';
import ImportConversion from './pages/ImportConversion';
import Users from './pages/Users';
import Settings from './pages/Settings';
import Privacy from './pages/Privacy';
import Cookie from './pages/Cookie';
import Terms from './pages/Terms';
import { FbDashboard, FbCampaigns, FbAdvertiserCampaigns, FbLeads, FbAnalytics, FbSettings } from './pages/facebook';
import { useAuth } from './context/AuthContext';
import { DemCalendar, DemDatabases, DemDatabaseDetail, DemAnalytics, DemMaildome, DemVirtualLists } from './pages/dem';

// Role-based home redirect
function RoleBasedHome() {
  const { user } = useAuth();
  
  if (user?.role === 'media_buyer') {
    return <Navigate to="/facebook" replace />;
  }
  return <Dashboard />;
}

// Simple layout for public pages
function PublicLayout({ children }) {
  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#F8FAFC', padding: '40px 20px' }}>
      <div style={{ maxWidth: 900, margin: '0 auto' }}>
        {children}
        <div style={{ textAlign: 'center', marginTop: 40, color: '#888', fontSize: 12 }}>
          © {new Date().getFullYear()} Digitoo Group S.r.l. - Via Confienza 10, 10121 Turin (TO), Italy
        </div>
      </div>
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            
            {/* Public Legal Pages */}
            <Route path="/privacy" element={<PublicLayout><Privacy /></PublicLayout>} />
            <Route path="/cookie" element={<PublicLayout><Cookie /></PublicLayout>} />
            <Route path="/terms" element={<PublicLayout><Terms /></PublicLayout>} />
            
            <Route path="/" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
              <Route index element={<RoleBasedHome />} />
              <Route path="partners" element={<Partners />} />
              <Route path="/partners/:id" element={<PartnerDetails />} />
              <Route path="advertisers" element={<Advertisers />} />
              <Route path="/advertisers/:id" element={<AdvertiserDetails />} />
              <Route path="campaigns" element={<Campaigns />} />
              <Route path="campaigns/:id" element={<CampaignDetails />} />
              <Route path="conversions" element={<Conversions />} />
              <Route path="conversions/:leadId" element={<ConversionDetails />} />
              <Route path="analytics" element={<Analytics />} />
              <Route path="import-conversion" element={<ImportConversion />} />
              <Route path="users" element={<Users />} />
              <Route path="settings" element={<Settings />} />
              {/* Facebook Routes - admin + media_buyer */}
              <Route path="/facebook" element={<FbDashboard />} />
              <Route path="/facebook/campaigns" element={<FbCampaigns />} />
              <Route path="/facebook/campaigns/:advertiserId" element={<FbAdvertiserCampaigns />} />
              <Route path="/facebook/leads" element={<FbLeads />} />
              <Route path="/facebook/analytics" element={<FbAnalytics />} />
              <Route path="/facebook/settings" element={<FbSettings />} />
              {/* DEM Routes - admin + manager */}
              <Route path="/dem/calendar" element={<DemCalendar />} />
              <Route path="/dem/databases" element={<DemDatabases />} />
              <Route path="/dem/databases/:id" element={<DemDatabaseDetail />} />
              <Route path="/dem/analytics" element={<DemAnalytics />} />
              <Route path="/dem/maildome" element={<DemMaildome />} />
              <Route path="/dem/virtual-lists" element={<DemVirtualLists />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
